<template>
	<div>
		<v-col cols="12" v-for="tabGroup in tabsData" :key="tabGroup.title">
			<h5 class="mb-0">{{ tabGroup.title }}</h5>
			<v-list two-line subheader class="py-0 mt-4" style="border: 1px solid #eff1f8; border-radius: 7px">
				<template v-for="(item, i) in tabGroup.items">
					<div v-if="item.allowed" :key="`${tabGroup.title}_${item.routeName}`">
						<router-link :key="`${tabGroup.title}_${item.routeName}`" :to="{ name: item.routeName, params: { tab: item } }">
							<v-list-item :class="{ 'v-list-item--active': isCurTab(item) }">
								<v-list-item-icon>
									<SIcon
										:name="item.icon"
										:width="item.iconWidth ? item.iconWidth : 19"
										:iconColor="isCurTab(item) ? '#1473E6' : '#869398'"
										style="position: relative; display: inline-block; left: 50%; transform: translateX(-50%); top: 10px; margin-left: 7px"
									/>
									<div class="left_indic_line"></div>
								</v-list-item-icon>
								<v-list-item-content>
									<!--eslint-disable vue/no-v-text-v-html-on-component-->
									<v-list-item-title v-text="item.title" style="color: #292829 !important; font-size: 14px"></v-list-item-title>
									<v-list-item-subtitle v-text="item.par" style="color: #919191 !important; font-size: 12px"></v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</router-link>
						<v-divider class="dev" :key="`divider_${item.routeName}`" v-if="i !== tabGroup.items.length - 1"></v-divider>
					</div>
				</template>
			</v-list>
		</v-col>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

import { isAccountOwner, hasAccountPermission } from '@/store/modules/account/getters';
import { isCustomDomainsEnabled, isAccEmailDomainsEnabled } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'SettingsTabs',
	props: {},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ isAccountOwner, isCustomDomainsEnabled, isAccEmailDomainsEnabled, hasAccountPermission }),
		tabsData() {
			return [
				{
					title: 'User settings',
					items: [
						{
							routeName: 'SettingsMe',
							title: 'My settings',
							par: 'Name, email, password',
							icon: 'my-settings',
							iconWidth: 19,
							allowed: true,
						},
						{
							routeName: 'ManageApps',
							title: 'My apps',
							par: 'Manage apps you use',
							icon: 'manage-apps-settings',
							iconWidth: 18,
							allowed: true,
						},
						// {
						// 	routeName: 'SettingsNotifications',
						// 	title: 'Notifications',
						// 	par: 'Customize your notifications ',
						// 	icon: 'notifications',
						// 	iconWidth: 19,
						// },
						// {
						// 	routeName: 'SettingsReferrals',
						// 	title: 'Referral rewards',
						// 	par: 'Share Ply with people to earn gifts',
						// 	icon: 'rewards',
						// 	iconWidth: 16,
						// },
						// {
						// 	routeName: 'SettingsDevices',
						// 	title: 'Your devices',
						// 	par: 'Details about your personal information',
						// 	icon: 'big-question-mark',
						// 	iconWidth: 13,
						// },
						// {
						// 	routeName: 'SettingsProfiles',
						// 	title: 'Account connections',
						// 	par: 'Manage your account connections',
						// 	icon: 'profiles',
						// 	iconWidth: 26,
						// 	allowed: true,
						// },
					],
				},
				{
					title: 'Workspace settings',
					items: [
						{
							routeName: 'SettingsOrganization',
							title: 'Settings',
							par: 'Workspace name',
							icon: 'settings',
							iconWidth: 19,
							allowed: true,
						},
						// {
						// 	routeName: 'SettingsCnames',
						// 	title: 'Cnames',
						// 	par: 'Manage Cnames for connected apps',
						// 	icon: 'cnames',
						// 	iconWidth: 26,
						// 	allowed: this.hasAccountPermission(AccountPermissions.ChangeAccount),
						// },
						// {
						// 	routeName: 'SettingsConfig',
						// 	title: 'Config data',
						// 	par: 'Description',
						// 	icon: 'notifications',
						// },
						{
							routeName: 'SettingsManageUsers',
							title: this.isAccountOwner(this.user.id) ? 'Manage workspace members' : 'Workspace members',
							par: this.isAccountOwner(this.user.id) ? 'Add and remove members' : '',
							icon: 'manage-users',
							iconWidth: 19,
							allowed: true,
						},
						{
							routeName: 'ManageGroups',
							title: 'Groups',
							par: 'Manage user groups',
							icon: 'manage-groups',
							iconWidth: 19,
							allowed: true,
						},
						{
							routeName: 'SettingsCustomDomains',
							title: this.isAccountOwner(this.user.id) ? 'Manage Custom Domains' : 'Custom Domains',
							par: this.isAccountOwner(this.user.id) ? '' : '',
							icon: 'globes',
							iconWidth: 19,
							allowed: this.isCustomDomainsEnabled,
						},
						{
							routeName: 'AccountEmailDomains',
							title: 'Email domains',
							par: 'Manage email domains',
							icon: 'manage-domains',
							iconWidth: 19,
							allowed: this.hasAccountPermission(AccountPermissions.ChangeAccount) && this.isAccEmailDomainsEnabled,
						},
						// {
						// 	routeName: 'SettingsPlanBilling',
						// 	title: 'Plan and Billing',
						// 	par: 'Description',
						// 	icon: 'plan-and-billing',
						// 	iconWidth: 18,
						// },
						// {
						// 	routeName: 'SettingsSecurity',
						// 	title: 'Security options',
						// 	par: 'Description',
						// 	icon: 'security',
						// 	iconWidth: 17,
						// },
						// {
						// 	routeName: 'SettingsAllowedApps',
						// 	title: 'Allowed apps',
						// 	par: 'Description',
						// 	icon: 'allowed-apps',
						// 	iconWidth: 18,
						// },
					],
				},
			];
		},
	},
	methods: {
		isCurTab(item) {
			return this.$route.name === item.routeName;
		},
	},
	mounted() {},
	data: () => ({}),
};
</script>

<style scoped>
h5 {
	font-size: 12px;
}
.dev {
	color: #eff1f8 !important;
	border-color: #eff1f8 !important;
	background-color: #eff1f8 !important;
}
.v-list-item--active {
	background: transparent;
	color: #1473e6;
}
.v-list-item--active::before {
	opacity: 0;
}
.left_indic_line {
	position: absolute;
	left: 6px;
	top: 6px;
	width: 3px;
	bottom: 6px;
	background: #1473e6;
	transform: scaleY(0);
	opacity: 0;
	transition: all 0.25s ease-in-out;
}
.v-list-item--active .left_indic_line {
	transform: scaleY(1);
	opacity: 1;
}
a {
	text-decoration: none;
}
</style>
